var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconMinimize = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4 13.1C10.3 13 10.1 13 10 13H4C3.4 13 3 13.4 3 14C3 14.6 3.4 15 4 15H7.6L2.3 20.3C1.9 20.7 1.9 21.3 2.3 21.7C2.5 21.9 2.7 22 3 22C3.3 22 3.5 21.9 3.7 21.7L9 16.4V20C9 20.6 9.4 21 10 21C10.6 21 11 20.6 11 20V14C11 13.9 11 13.7 10.9 13.6C10.8 13.4 10.6 13.2 10.4 13.1ZM21.7 2.3C21.3 1.9 20.7 1.9 20.3 2.3L15 7.6V4C15 3.4 14.6 3 14 3C13.4 3 13 3.4 13 4V10C13 10.1 13 10.3 13.1 10.4C13.2 10.6 13.4 10.8 13.6 10.9C13.7 11 13.9 11 14 11H20C20.6 11 21 10.6 21 10C21 9.4 20.6 9 20 9H16.4L21.7 3.7C22.1 3.3 22.1 2.7 21.7 2.3Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconMinimize);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "media/IconMinimize.7e5dbff63594a540e2563f669a346106.svg";